export enum ToolVersionStatsType {
  LINKED_EPDS = 'linked-epds',
  PUBLISHED_EPDS = 'published-epds',
  PUBLISHED_EPD_VERSIONS = 'published-epd-versions',
}
